export const LEILAO_LABEL = "Leilão";

export const isLeilaoOrigem = (origem?: string | null): boolean => {
  if (!origem) return false;
  const normalized = String(origem).trim().toLowerCase();
  return normalized.includes("leilao") || normalized.includes("leilão");
};
